import { render, staticRenderFns } from "./TopicRegister.vue?vue&type=template&id=22418b7d"
import script from "./TopicRegister.vue?vue&type=script&lang=js"
export * from "./TopicRegister.vue?vue&type=script&lang=js"
import style0 from "./TopicRegister.vue?vue&type=style&index=0&id=22418b7d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports